/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCapsule = createReactComponent("capsule", "IconCapsule", [
  [
    "path",
    {
      d: "M6 3m0 6a6 6 0 0 1 6 -6h0a6 6 0 0 1 6 6v6a6 6 0 0 1 -6 6h0a6 6 0 0 1 -6 -6z",
      key: "svg-0"
    }
  ]
]);

export { IconCapsule as default };
//# sourceMappingURL=IconCapsule.js.map
